import React from 'react';

import { useTranslation } from '@lt/localization';
import OrderSuccess from 'src/components/OrderSuccess';

import { REDIRECT_TO_ORDER_DELAY } from '../../store/constants/view';

type Props = {
  goToOrderPage: () => void;
  isPaylate: boolean;
};

const OrderSuccessCheckout = (props: Props) => {
  const { goToOrderPage, isPaylate } = props;

  const { t } = useTranslation();

  return (
    <div>
      <OrderSuccess
        time={REDIRECT_TO_ORDER_DELAY / 1000}
        text={t('commonPages.orderSuccess.orderPaid.description')}
        goToOrderPage={goToOrderPage}
        needToRedirect={!isPaylate}
        title={t('commonPages.orderSuccess.orderPaid.title')}
      />
    </div>
  );
};

export default OrderSuccessCheckout;
